import { useState } from "react";
import {C, withAlpha } from "../constants/theme";
import { CORES_PRESET } from "../constants/colors";
import { Btn } from "./ui/Btn";

const COR_HEX_FALLBACK = {
  preto:"#1a1a1a", negro:"#1a1a1a", black:"#111",
  branco:"#f0f0f0", white:"#f0f0f0",
  cinza:"#808080", gray:"#808080", grey:"#808080", prata:"#94a3b8", silver:"#94a3b8",
  vermelho:"#dc2626", red:"#dc2626", vinho:"#9f1239",
  azul:"#2563eb", blue:"#2563eb", ciano:"#06b6d4", cyan:"#06b6d4", turquesa:"#2dd4bf",
  verde:"#16a34a", green:"#16a34a", lima:"#84cc16",
  amarelo:"#eab308", yellow:"#eab308",
  laranja:"#ea580c", orange:"#ea580c", coral:"#f97316",
  roxo:"#7c3aed", purple:"#7c3aed", violeta:"#8b5cf6", lilas:"#a78bfa", magenta:"#d946ef",
  rosa:"#ec4899", pink:"#ec4899",
  marrom:"#92400e", brown:"#92400e", bege:"#d4b483", natural:"#f5e6c8",
  cobre:"#b45309", copper:"#b45309", dourado:"#f59e0b", gold:"#f59e0b",
  transparente:"#bae6fd",
};

function hexDaCor(nome, todasCores) {
  const c = todasCores.find(c => c.nome?.toLowerCase() === (nome||"").toLowerCase());
  if (c?.hex) return c.hex;
  const lower = (nome || "").toLowerCase().trim();
  for (const [k, v] of Object.entries(COR_HEX_FALLBACK)) {
    if (lower.includes(k)) return v;
  }
  return null;
}

export function CorSelector({ value, onChange, coresCustom = [], onAddCor }) {
  const [novaCorNome, setNovaCorNome] = useState(""); const [novaCorHex, setNovaCorHex] = useState("#ff0000"); const [addMode, setAddMode] = useState(false);
  const [gradeAberta, setGradeAberta] = useState(false);
  const todasCores = [...CORES_PRESET, ...coresCustom];
  const hexAtual = value && (value==="transparente" ? "transparent" : hexDaCor(value, todasCores));

  return (
    <div>
      <label style={{ color:C.muted, fontSize:12, fontWeight:600, letterSpacing:1, display:"block", marginBottom:6 }}>COR</label>

      {/* Campo de texto + amostra/abrir grade no canto */}
      <div style={{ position:"relative" }}>
        <input
          aria-label="Cor do filamento"
          value={value || ""}
          onChange={e=>onChange(e.target.value)}
          placeholder="Escreva a cor (ex: Verde Neon)"
          style={{ width:"100%", boxSizing:"border-box", background:C.card, border:"1px solid "+C.border, borderRadius:8, color:C.text, padding:"10px 50px 10px 12px", fontSize:14, outline:"none" }}
        />
        <button
          type="button"
          onClick={()=>setGradeAberta(v=>!v)}
          title="Escolher cor da grade"
          style={{ position:"absolute", right:6, top:"50%", transform:"translateY(-50%)", width:30, height:30, borderRadius:6, cursor:"pointer", padding:0,
            background: hexAtual==="transparent" ? "linear-gradient(135deg,#fff 50%,#ccc 50%)" : (hexAtual || C.panel),
            border:"1px solid "+(gradeAberta ? C.accent2 : C.border), display:"flex", alignItems:"center", justifyContent:"center",
            color: hexAtual ? "transparent" : C.muted, fontSize:14 }}>
          {hexAtual ? "" : "🎨"}
        </button>
      </div>

      {/* Grade de cores escondida */}
      {gradeAberta && (
        <div style={{ marginTop:8, padding:10, background:C.panel, borderRadius:8, border:"1px solid "+C.border }}>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:addMode?10:0 }}>
            {todasCores.map(cor => (
              <div key={cor.nome} onClick={()=>{ onChange(cor.nome); setGradeAberta(false); }} title={cor.nome}
                style={{ width:28, height:28, borderRadius:6, cursor:"pointer", background:cor.hex==="transparent"?"linear-gradient(135deg,#fff 50%,#ccc 50%)":cor.hex, border:value===cor.nome?"2px solid "+C.accent2:"2px solid "+C.border, boxShadow:value===cor.nome?"0 0 0 2px "+withAlpha(C.accent2, "66"):"none", boxSizing:"border-box" }} />
            ))}
            <div onClick={()=>setAddMode(!addMode)} style={{ width:28, height:28, borderRadius:6, cursor:"pointer", background:C.card, border:"2px dashed "+C.border, display:"flex", alignItems:"center", justifyContent:"center", color:C.muted, fontSize:16, fontWeight:700 }}>+</div>
          </div>
          {addMode && (
            <div style={{ display:"flex", gap:8, alignItems:"flex-end", flexWrap:"wrap" }}>
              <div><label style={{ color:C.muted, fontSize:11, display:"block", marginBottom:4 }}>NOME</label>
                <input value={novaCorNome} onChange={e=>setNovaCorNome(e.target.value)} placeholder="Ex: Verde Neon" style={{ background:C.card, border:"1px solid "+C.border, borderRadius:6, color:C.text, padding:"6px 10px", fontSize:13, outline:"none", width:110 }} /></div>
              <div><label style={{ color:C.muted, fontSize:11, display:"block", marginBottom:4 }}>COR</label>
                <input type="color" value={novaCorHex} onChange={e=>setNovaCorHex(e.target.value)} style={{ width:40, height:34, padding:2, borderRadius:6, border:"1px solid "+C.border, cursor:"pointer", background:"none" }} /></div>
              <Btn small color={C.accent2} onClick={()=>{ if(!novaCorNome.trim()) return; onAddCor({ nome:novaCorNome.trim(), hex:novaCorHex }); onChange(novaCorNome.trim()); setNovaCorNome(""); setAddMode(false); setGradeAberta(false); }}>Salvar</Btn>
              <Btn small outline onClick={()=>setAddMode(false)}>✕</Btn>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
